// extracted by mini-css-extract-plugin
export var buttonsContainer = "UpgradeRedesign_buttonsContainer__9qbud";
export var couponCodeWrapper = "UpgradeRedesign_couponCodeWrapper__rwmwC";
export var ctaSectionWrapper = "UpgradeRedesign_ctaSectionWrapper__Fl96Q";
export var footerCta = "UpgradeRedesign_footerCta__S+wPy";
export var upgradeContainer = "UpgradeRedesign_upgradeContainer__JqAkw";
export var upgradeWrapper = "UpgradeRedesign_upgradeWrapper__j3qqt";